/* NEON CREATIONS — CORE JS (assets/nc-core.js)
   Lights [data-nc-light] headings once, when they scroll into view. */
(function () {
  var root = document.documentElement;
  root.setAttribute('data-nc-core', 'ready');
  if (!root.classList.contains('nc-js') || !('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-lit');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.35 });

  function scan(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-nc-light]:not(.is-lit)'), function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
